module.exports = __webpack_public_path__ + "static/img/3.a6c257a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/2/zh/3.png
// module id = GGKl
// module chunks = 0